import React from "react";
import PropTypes from "prop-types";
import i18next from 'i18next';
import { scaleTime } from "d3-scale";
import { format } from "d3-format";
import { timeFormat } from "d3-time-format";
import {
EdgeIndicator
} from "react-stockcharts/lib/coordinates";
import { ChartCanvas, Chart } from "react-stockcharts";
import {
    ScatterSeries,
    SquareMarker,
    TriangleMarker,
    CircleMarker,
    LineSeries,
} from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import {
    CrossHairCursor,
    MouseCoordinateX,
    MouseCoordinateY,
} from "react-stockcharts/lib/coordinates";

import { HoverTooltip } from "react-stockcharts/lib/tooltip";
import { fitWidth } from "react-stockcharts/lib/helper";
import { last } from "react-stockcharts/lib/utils";
import styles from './Chart.less';
import CustomOHLCTooltip from './CustomOHLCTooltip';
import $ from 'jquery';
import config from './../../config';
let dynamicTime = true;
import { connect } from 'react-redux';
import * as commonActions from './../../actions/commonActions';
@connect(
  state => ({
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  language:state.dashboardRoot.commonReducer.language,
  userDetail: state.auth.userDetail,
}),
{ ...commonActions})

class MultipleLineComponent extends React.Component {
		componentDidMount() {
				this.node.subscribe("zoomlistner", { listener: this.handleEvents });
		}
		componentWillUnmount() {
				this.node.unsubscribe("zoomlistner")
		}
		handleEvents = (type, moreProps, state) => {
      try{
            if (type === "zoom" || type === "panend") {
                if (this.props.onZoomEvent) {
                        this.props.onZoomEvent(moreProps.xScale.domain());
                }
            }
      }catch(e){
        this.props.logFileCreation({error:e.message, originFunction:'handleEvents', component:"MultipleLineComponent"});
      }
		}
    render() {
        const { data, type, width, ratio, durationType, zoomSet, decimals } = this.props;
        $(document).ready(function(){
          $("rect").hover(function(){
            dynamicTime = false;
          },
          function(){
            dynamicTime = true;
          });
        });
        const xAccessor = d => d && d.date ? d.date : '';
        const start = xAccessor(data[0]);
        const end = xAccessor(data[data.length - 1]);
        let testmsg = "MultipleLine";
        //const xExtents = [start, end];
        var margin = {
            top: 20,
            right: 0,
            bottom: 40,
            left: 70
        };
        var dataLength = 0;
        if (this.props.data.length !== 0) {
          dataLength = Number(this.props.data[this.props.data.length-1].ask).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}).length;
        }
        var height = (this.props.height > 400 ? this.props.height : 400 ) - margin.top - margin.bottom;
        var gridHeight = height - margin.top - margin.bottom;
        var gridWidth = width - (dataLength > 6 ? 70 : 50);
        var color='#000';
        var axisColor='#000';
        var yGrid =  {
            innerTickSize: -1 * (width - 70),
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.2,
            tickStrokeWidth: 1,
            stroke: axisColor,
            tickStroke:color
        };
        var xGrid = {
            innerTickSize: -1 * gridHeight,
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.2,
            tickStrokeWidth: 1,
            tickStroke:color,
            stroke: axisColor,
        } ;
        var yGridDark =  {
            innerTickSize: -1 * (width - 70),
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.3,
            tickStrokeWidth: 1,
            tickStroke:"#b2b1ae",
            stroke: "#b2b1ae"
        };
        var xGridDark = {
            innerTickSize: -1 * gridHeight,
            tickStrokeDasharray: 'Solid',
            tickStrokeOpacity: 0.3,
            tickStrokeWidth: 1,
            tickStroke:"#b2b1ae",
            stroke: "#b2b1ae"
        } ;
        const defTickTimeFormat = timeFormat("%H:%M:%S");

        let tickTimeFormat = d3.time.format.multi([
          [":%Ss", function(d) { return d.getSeconds(); }],
          ["%H:%M", function(d) { return d.getHours() || d.getMinutes(); }],
          ["%H:%M", function() { return true }]
        ]);

        var tickFormatFn = function(d) {
            return tickTimeFormat(d);
        };
        var numberFormat = function(d) {
          return d.toLocaleString(navigator.language,{ minimumFractionDigits:decimals,maximumFractionDigits:decimals});
        }
        let ticksObject = {}
        switch(durationType) {
          case 'Tick':
            // Points every 5 secs
            ticksObject = {unit: d3.time.minutes, value: 10};
            break;
          case 'Minute':
            // Points every 5 minutes
            ticksObject = {unit: d3.time.minutes, value: 12};
            break;
          case 'Hour':
            // Points every 1 hour
            ticksObject = {unit: d3.time.days, value: 12};
            break;
          default:
            ticksObject = {unit: d3.time.hours, value: 12};
        }

        let tooltipContent = ({ currentItem }) => {
            if (this.props.language == 'AR') {
              return {
                x: defTickTimeFormat(currentItem.date) + ': '+i18next.t('time'),
                y: [{
                      label: Number(currentItem.ask).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
                      value: (this.props.userDetail.ShowBuySellInRates === true ? i18next.t('buy'):i18next.t('ask')),
                  },{
                      label: Number(currentItem.bid).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
                      value: (this.props.userDetail.ShowBuySellInRates === true ? i18next.t('sell'):i18next.t('bid')),
                  }].filter(line => line.value)
              };
            }
            else {
              return {
                x: i18next.t('time') + ': '+defTickTimeFormat(currentItem.date),
                y: [{
                      label: (this.props.userDetail.ShowBuySellInRates === true ? i18next.t('buy'):i18next.t('ask')),
                      value: Number(currentItem.ask).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
                  },{
                      label: (this.props.userDetail.ShowBuySellInRates === true ? i18next.t('sell'):i18next.t('bid')),
                      value: Number(currentItem.bid).toLocaleString(navigator.language,{ minimumFractionDigits:this.props.decimals,maximumFractionDigits:this.props.decimals}),
                  }].filter(line => line.value)
              };
            }
        }

        let highestPoint = Math.max(d3.max(data, function (d) { return Number(d.ask) }), d3.max(data, function (d) { return Number(d.bid) }));
        let lowestPoint = Math.min(d3.min(data, function (d) { return Number(d.ask) }), d3.min(data, function (d) { return Number(d.bid) }));
        let widthConst =  280 ;
        let ohlcTooltipOrigin = [
            this.props.width< 500 ? -40 : (this.props.language != 'AR' ? 0 : 500),
            -38
          ];

        //---to re-render chart zoom-level
        let a = zoomSet;
        if (data.length< 200) {
          a = start;
        }
        const zoomLevel = this.props.zoomLevel ? this.props.zoomLevel.map((item) => new Date(item)) : undefined;
        const xExtents = zoomLevel !== undefined ? [zoomLevel[0]  ,end] : [a, end];
        return (
            <ChartCanvas ratio={ratio} width={width} height={height}
                    margin={margin}
                    seriesName="Line"
                    data={data}
                    //clamp={'both'}
                    xScale={scaleTime()}
                    xAccessor={xAccessor}
										displayXAccessor={xAccessor}
										ref={node => { this.node = node; } }
                    xExtents={xExtents}
                    pointsPerPxThreshold={120}
            >
                <Chart id={2}
                    yExtents={d => {
                        let high = (d.ask > d.bid ? d.ask : d.bid) + Math.pow(10, -1 * (decimals-1));
                        let low = (d.ask < d.bid ? d.ask : d.bid) - Math.pow(10, -1 * (decimals-1));
                        return [high, low];
                    }}
                >
                { this.props.selectedCssColor==="DR" ?
                <XAxis
                    axisAt="bottom"
                    orient="bottom"
                    tickFormat={tickFormatFn}
                    {...xGridDark}
                    ticks={6}
                />
                :
                <XAxis
                    axisAt="bottom"
                    orient="bottom"
                    tickFormat={tickFormatFn}
                    {...xGrid}
                    ticks={6}
                />
              }
                { this.props.selectedCssColor==="DR" ?
                <YAxis
                    axisAt="left"
                    orient="left"
                    tickFormat={numberFormat}
                    zoomEnabled={false}
                    {...yGridDark}
                     ticks={4}
                />
                  :

                    <YAxis
                        axisAt="left"
                        orient="left"
                        tickFormat={numberFormat}
                        zoomEnabled={false}
                        {...yGrid}
                         ticks={4}
                    />
                  }
                    {/* <EdgeIndicator
                        itemType="last"
                        orient="right"
                        edgeAt="right"
      						      yAccessor={d => d.bid}
                        displayFormat={format(",." + decimals + "f")}
                        fill="#ff0000"
                        arrowWidth={0}
                        rectHeight={18}
                    /> */}
                    <LineSeries
                        yAccessor={d => d.bid}
                        // red
                        stroke={config.decreaseRateColor}
                        strokeDasharray="Solid"
                        highlightOnHover
                    />
                    <LineSeries
                        yAccessor={d => d.ask}
                        // green
                        stroke={config.increaseRateColor}
                        strokeDasharray="Solid"
                        highlightOnHover
                    />

                    {/* <EdgeIndicator
                        itemType="last"
                        orient="right"
                        edgeAt="right"
                        yAccessor={d => d.ask}
                        displayFormat={format(",." + decimals + "f")}
                        fill="#219a00"
                        arrowWidth={0}
                        rectHeight={18}
                    /> */}
                    <HoverTooltip
                      tooltipContent={tooltipContent}
                      fontSize={13}
                      bgfill={this.props.selectedThemes.tooltipHoverBg}
                      fill={this.props.selectedThemes.tooltipHoverBg}
                      fontFill={this.props.selectedThemes.tooltipHoverClr}
                      stroke={this.props.selectedThemes.tooltipHoverClr}
                    />
                    <CustomOHLCTooltip
                        forChart={1}
                        MultiplelineHeader={testmsg}
                        fontSize={13}
                        className={this.props.language != 'AR' ? `${styles.ohlcTooltip}`:`${styles.ohlcTooltip} chartTimeHead`}
                        origin={ohlcTooltipOrigin}
                        ohlcFormat={decimals}
                        lastPointFromGraph={data[data.length-1]}
                        dynamicTimeMulti={dynamicTime}
                        styleObj = {this.props.styleObj}
                    />
                </Chart>
            </ChartCanvas>

        );
    }
}

MultipleLineComponent.propTypes = {
    data: PropTypes.array.isRequired,
    width: PropTypes.number.isRequired,
    ratio: PropTypes.number.isRequired,
    type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
		durationType: PropTypes.oneOf(['Tick', 'Minute', 'Hour']).isRequired,
		onZoomEvent: PropTypes.func,
    zoomLevel: PropTypes.array
};

MultipleLineComponent.defaultProps = {
    type: "svg"
};
MultipleLineComponent = fitWidth(MultipleLineComponent);

export default MultipleLineComponent;
